export default "__VITE_PUBLIC_ASSET__9d6efbb1__"